import { SimulateRepository } from 'application/repositories/SimulateRepository';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import {
    CfSimCompareResponse,
    CfSimDetailResponse,
    SimHistoryResponse,
    SimListResponse,
    SimulateAssessmentResponse,
    SimulateBreakEntity,
    SimulateBreakGetResponse,
    SimulateCashFlowEntity,
    SimulateCashFlowGetResponse,
    SimulateCashFlowListedPropertyResponse,
    SimulateCreateCashFlowEntity,
    SimulateEntity,
    SimulateLoanEntity,
    SimulateLoanFinancialResponse,
    SimulateLoanResponse,
    SimulateSaleResponse,
} from 'domain/entities/SimulateEntity';

export class SimulateUseCase implements SimulateUseCaseInterface {
    private simulateRepo: SimulateRepository;
    constructor(simulateRepo: SimulateRepository) {
        this.simulateRepo = simulateRepo;
    }

    async createSimulateSale(payload: SimulateEntity): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createSimulateSale(payload);
    }

    async getSimulateSale(payload: SimulateEntity): Promise<SimulateSaleResponse> {
        return await this.simulateRepo.getSimulateSale(payload);
    }

    async getSimulateLoadFinancial(checkFlag?: string): Promise<SimulateLoanFinancialResponse> {
        return await this.simulateRepo.getSimulateLoadFinancial(checkFlag);
    }
    async getMasterFee(): Promise<any> {
        return await this.simulateRepo.getMasterFee();
    }
    async createSimulateCashFlow(
        payload: SimulateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createSimulateCashFlow(payload);
    }
    async createCashFlowSimWithListedProperty(
        payload: SimulateCreateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createCashFlowSimWithListedProperty(payload);
    }
    async getSimulateCashFlow(
        payload: SimulateCashFlowEntity,
    ): Promise<SimulateCashFlowGetResponse> {
        return await this.simulateRepo.getSimulateCashFlow(payload);
    }

    async createSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createSimulateLoan(payload);
    }

    async createTempSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createTempSimulateLoan(payload);
    }

    async getSimulateLoan(params: { simId: number }): Promise<SimulateLoanResponse> {
        return await this.simulateRepo.getSimulateLoan(params);
    }
    async getSimulateLoanDefaultValue(): Promise<SimulateLoanResponse> {
        return await this.simulateRepo.getSimulateLoanDefaultValue();
    }
    async createSimulateBreak(payload: SimulateBreakEntity): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.createSimulateBreak(payload);
    }

    async getSimulateBreak(payload: SimulateBreakEntity): Promise<SimulateBreakGetResponse> {
        return await this.simulateRepo.getSimulateBreak(payload);
    }
    async getSimulateAssessment(params: {
        listedPropertyId: number;
    }): Promise<SimulateAssessmentResponse> {
        return await this.simulateRepo.getSimulateAssessment(params);
    }
    async getCashFlowSimOfListedProperty(params: {
        simId: number;
    }): Promise<SimulateCashFlowListedPropertyResponse> {
        return await this.simulateRepo.getCashFlowSimOfListedProperty(params);
    }
    async updateCashFlowSim(
        payload: SimulateCreateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.simulateRepo.updateCashFlowSim(payload);
    }
    async getSimHistory(type?: string): Promise<SimHistoryResponse> {
        return await this.simulateRepo.getSimHistory(type);
    }
    async getSimModalList(type?: string): Promise<SimListResponse> {
        return await this.simulateRepo.getSimModalList(type);
    }
    async getDataCompare(params: { id1: number; id2: number }): Promise<CfSimCompareResponse> {
        return await this.simulateRepo.getDataCompare(params);
    }
    async getSimDetail(id: number): Promise<CfSimDetailResponse> {
        return await this.simulateRepo.getSimDetail(id);
    }
}

export interface SimulateUseCaseInterface {
    createSimulateSale(payload: SimulateEntity): Promise<PostPutDeleteBaseResponse>;
    getSimulateSale(payload: SimulateEntity): Promise<SimulateSaleResponse>;
    getSimulateLoadFinancial(checkFlag?: string): Promise<SimulateLoanFinancialResponse>;
    getMasterFee(): Promise<any>;
    createSimulateCashFlow(payload: SimulateCashFlowEntity): Promise<PostPutDeleteBaseResponse>;
    getSimulateCashFlow(payload: SimulateCashFlowEntity): Promise<SimulateCashFlowGetResponse>;
    createSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse>;
    getSimulateLoan(params: { simId: number }): Promise<SimulateLoanResponse>;
    getSimulateLoanDefaultValue(): Promise<SimulateLoanResponse>;
    createSimulateBreak(payload: SimulateBreakEntity): Promise<PostPutDeleteBaseResponse>;
    getSimulateBreak(payload: SimulateBreakEntity): Promise<SimulateBreakGetResponse>;
    getSimulateAssessment(params: {
        listedPropertyId: number;
    }): Promise<SimulateAssessmentResponse>;
    createCashFlowSimWithListedProperty(
        payload: SimulateCreateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse>;
    getCashFlowSimOfListedProperty(params: {
        simId: number;
    }): Promise<SimulateCashFlowListedPropertyResponse>;
    updateCashFlowSim(payload: SimulateCreateCashFlowEntity): Promise<PostPutDeleteBaseResponse>;
    createTempSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse>;
    getSimHistory(type?: string): Promise<SimHistoryResponse>;
    getSimModalList(type?: string): Promise<SimListResponse>;
    getDataCompare(params: { id1: number; id2: number }): Promise<CfSimCompareResponse>;
    getSimDetail(id: number): Promise<CfSimDetailResponse>;
}
